import cn from "classnames";
import { Button } from "@jhool-io/fe-components";
import * as React from "react";
import { useErrorBoundary } from "react-error-boundary";
import styles from "./ContentFallback.module.scss";
import { useAppDispatch, useAppSelector } from "../../../hooks/useRedux";
import { toggleNavState } from "../../../redux/features/nav/navSlice";
import useNewBackground from "../../../hooks/useNewBackground";
import MenuIcon from "../../../icons/Menu";

export default function ContentFallback() {
    const { isOpen } = useAppSelector((state) => state.nav);
    const dispatch = useAppDispatch();

    const useNewBg = useNewBackground();

    const { resetBoundary } = useErrorBoundary();

    return (
        <div
            className={cn(styles.main, {
                [styles.main_full]: !isOpen,
            })}
            id="main"
        >
            <div
                className={cn(styles.navbar, {
                    [styles.navbar_newbg]: useNewBg,
                })}
            >
                {!isOpen && (
                    <Button
                        size="auto"
                        variant="can-hover"
                        onClick={() => dispatch(toggleNavState())}
                    >
                        <MenuIcon className="stroke-textSec" />
                    </Button>
                )}
            </div>
            <div className={styles.wrap}>
                <h3>Something went wrong</h3>
                <p>
                    You just encountered an unexpected error. We have been made
                    aware of it and we will address this issue as quickly as we
                    can. Please use the feedback button to provide more
                    information on the issue. Thank you for your understanding.
                </p>
                <Button
                    onClick={resetBoundary}
                    style={{
                        marginTop: "20px",
                    }}
                >
                    Go back
                </Button>
            </div>
        </div>
    );
}
